import { render, staticRenderFns } from "./candidateDetailsDialog.vue?vue&type=template&id=86e6ded0&"
import script from "./candidateDetailsDialog.vue?vue&type=script&lang=js&"
export * from "./candidateDetailsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports